import request from '../utils/request';
import { REPORT_TYPES } from '../utils/reportTypes';
import { invalidateFeedSnapshots } from '../utils/searchFeedReturn';

export function isValidReportId(id) {
  return /^[1-9]\d*$/.test(String(id)) && Number.isSafeInteger(Number(id)) && Number(id) <= 2147483647;
}

export const isValidReactionId = isValidReportId;

function sendReport(target, id, type) {
  if (!isValidReportId(id) || !REPORT_TYPES.includes(type)) {
    return Promise.resolve({ success: false, statusCode: 400 });
  }
  // Keep the identifier in the URL: request() retains all supplied data in the body.
  const prefix = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  return request({ url: `${prefix}/${target}/${id}/report`, method: 'POST', data: { type } }).then(response => {
    if (response?.success) invalidateFeedSnapshots();
    return response;
  });
}

export function sendReactionReport(id, type) {
  return sendReport('reaction', id, type);
}

export function sendUserReport(id, type) {
  return sendReport('user', id, type);
}
